import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/EngagementCampaignInfluencerPostDaily.graphql';
import { Query, QueryengagementCampaignReportArgs } from '../../__generated__/globalTypes';

export const useEngagementCampaignInfluencerPostDailyQuery = (
  options?: QueryHookOptions<Query, QueryengagementCampaignReportArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryengagementCampaignReportArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useEngagementCampaignInfluencerPostDailyLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryengagementCampaignReportArgs>
): QueryResult<Query, QueryengagementCampaignReportArgs> & {
  getEngagementCampaignInfluencerPostDaily: LazyQueryExecFunction<Query, QueryengagementCampaignReportArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getEngagementCampaignInfluencerPostDaily, result] = useLazyQuery<Query, QueryengagementCampaignReportArgs>(
    QUERY,
    {
      onError: (error) => {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      },
      ...options
    }
  );

  return { getEngagementCampaignInfluencerPostDaily, ...result };
};

export const useEngagementCampaignInfluencerPostDailyPromiseQuery = () => {
  const client = useApolloClient();

  const getEngagementCampaignInfluencerPostDaily = useCallback(
    (options?: Omit<QueryOptions<QueryengagementCampaignReportArgs, Query>, 'query'>) =>
      client.query<Query, QueryengagementCampaignReportArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getEngagementCampaignInfluencerPostDaily };
};
// Suspense Query Hooks
export const useEngagementCampaignInfluencerPostDailySuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryengagementCampaignReportArgs>
) => {
  const result = useSuspenseQuery<Query, QueryengagementCampaignReportArgs>(QUERY, {
    ...options
  });

  return result;
};
